import script from "./CreateOrderSuccess.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateOrderSuccess.vue?vue&type=script&lang=ts&setup=true"

import "./CreateOrderSuccess.vue?vue&type=style&index=0&id=b8f56230&lang=scss"

const __exports__ = script;

export default __exports__